const setInnerLoad = (innerLoadObj) => {
    return {
        type: "SET_INNER_LOAD",
        payload: innerLoadObj
    }
}

export default {
    setInnerLoad
}